<template>
    <div class="user-edite-page scrollable" ref="page">
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'users' }">
                    Users List
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="top-bar" v-if="page === 'user-edit'">
            <div class="count-user">
                <span class="name">{{ userData.first_name }} {{ userData.last_name }}</span>
            </div>
            <div class="created_at">
                <span>created at: {{ getDateEDTFormat(userData.created_at) }}</span>

            </div>
        </div>

        <div class="tabs_wrp">
            <el-tabs type="border-card"
                     tab-position="top"
                     v-model="activeTab"
                     :before-leave="moveToSecontTab">
                <el-tab-pane
                      name="userInfo"
                      :lazy="true">
                    <span slot="label">
                        <i class="mdi mdi-account-box-outline"></i> User info</span>
                    <user-info
                      ref="userInfoForm"
                      :user-data="userData"
                      :format-data="formatData"
                      :isUserInfoScreenProcess="isUserInfoScreenProcess"
                      :isGeneratePDF="isGeneratePDF"
                      :imgArray="imgArray"
                      :screenshotPage="this.$refs.page"
                      @toggleConfig="toggleConfig"
                      @triggerNextTab="triggerNextTab"
                      @disableGeneratePDF="disableGeneratePDF"
                      @addNewImage="addNewImage"
                      @takeScreenshots="takeScreenshots"
                      @changeTab="changeTab"
                    />
                </el-tab-pane>

                <el-tab-pane name="userConfig"
                    @tab-click="moveToSecontTab"
                    :lazy="true"
                    :disable="disable">
                    <span slot="label">
                        <i class="mdi mdi-settings"></i> Config
                    </span>
                    <config-user-data
                            ref="userConfig"
                            :isScreenProcess="isScreenProcess"
                            :isConfigScreenProcess="isConfigScreenProcess"
                            :screenshotPage="this.$refs.page"
                            @toggleReport="toggleReport"
                            @triggerNextTab="triggerNextTab"
                            @addNewImage="addNewImage"
                            :user-data="userData"
                            :format-data="formatData"/>
                </el-tab-pane>

                <el-tab-pane name="reports" v-if="page === 'user-edit'" :lazy="true">
                     <span slot="label">
                        <i class="mdi mdi-view-list"></i> Reports</span>
                    <transition name="slide-fade" mode="out-in">
                        <user-scans
                                v-if="!reportData.length"
                                :isScreenProcess="isScreenProcess"
                                :isReportScreenProcess="isReportScreenProcess"
                                :screenshotPage="this.$refs.page"
                                @togglePaymentInfo="togglePaymentInfo"
                                @triggerNextTab="triggerNextTab"
                                @addNewImage="addNewImage"
                                />
                        <report-show
                                :isScreenProcess="isScreenProcess"
                                :isReportScreenProcess="isReportScreenProcess"
                                @togglePaymentInfo="togglePaymentInfo"
                                @triggerNextTab="triggerNextTab"
                                @addNewImage="addNewImage"
                                :report-data="reportData"
                                :report-info="reportInfo"
                                v-else/>
                    </transition>


                </el-tab-pane>
                <el-tab-pane name="paymentInfo" label="Payment info" v-if="page === 'user-edit'"
                     :lazy="true">
                                      <span slot="label">
                        <i class="mdi mdi-square-inc-cash"></i> Payment info
                    </span>
                    <transition name="slide-fade" mode="out-in">
                        <user-payment
                                :user-data="userData"
                                :isScreenProcess="isScreenProcess"
                                :isPaymentInfoScreenProcess="isPaymentInfoScreenProcess"
                                :screenshotPage="this.$refs.page"
                                @togglePaymentHistory="togglePaymentHistory"
                                @triggerNextTab="triggerNextTab"
                                @addNewImage="addNewImage"
                                v-if="userData"/>
                    </transition>

                  </el-tab-pane>

                <el-tab-pane
                    label="Payment history"
                    name="paymentHistory"
                    v-if="page === 'user-edit'"
                     :lazy="true">
                      <span slot="label">
                        <i class="mdi mdi-history"></i> Payment history
                    </span>
                    <transition name="slide-fade" mode="out-in">
                        <payments-history
                                :user-data="userData"
                                :isScreenProcess="isScreenProcess"
                                :isPaymentHistoryScreenProcess="isPaymentHistoryScreenProcess"
                                :screenshotPage="this.$refs.page"
                                @toggleUserLog="toggleUserLog"
                                @triggerNextTab="triggerNextTab"
                                @addNewImage="addNewImage"
                                v-if="userData"/>
                    </transition>

                  </el-tab-pane>

                <el-tab-pane name="userLog" label="User log" v-if="page === 'user-edit'"
                     :lazy="true">
                      <span slot="label">
                        <i class="mdi mdi-sunglasses"></i> User log
                    </span>
                    <transition name="slide-fade" mode="out-in">
                        <user-log
                                :isScreenProcess="isScreenProcess"
                                :isUserLogScreenProcess="isUserLogScreenProcess"
                                :screenshotPage="this.$refs.page"
                                @triggerNextTab="triggerNextTab"
                                @addNewImage="addNewImage"
                                :user-data="userData"/>
                    </transition>

                  </el-tab-pane>
              <el-tab-pane name="userEmailLog" label="Email log" v-if="page === 'user-edit'"
                           :lazy="true">
                      <span slot="label">
                        <i class="mdi mdi-email-open"></i> Email log
                    </span>
                <transition name="slide-fade" mode="out-in">
                  <user-email-log
                      :isScreenProcess="isScreenProcess"
                      :isUserLogScreenProcess="isUserLogScreenProcess"
                      :screenshotPage="this.$refs.page"
                      @triggerNextTab="triggerNextTab"
                      @addNewImage="addNewImage"
                      :user-data="userData"
                      />
                </transition>

              </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import UserInfo from '../../../components/UsersList/UserEdite/UserInfo'
  import ConfigUserData from '../../../components/UsersList/UserEdite/ConfigUserData'
  import UserScans from '../../../components/UsersList/UserEdite/UserScans'
  import UserLog from '../../../components/UsersList/UserEdite/UserLog'
  import UserEmailLog from '../../../components/UsersList/UserEdite/UserEmailLog'
  import UserPayment from '../../../components/UsersList/UserEdite/UserPayment'
  import ReportShow from '../../../components/UsersList/UserEdite/ReportShow'
  import PaymentsHistory from '../../../components/UsersList/UserEdite/PaymentsHistory'



  export default {
    name: 'UserEdite',
    components: {
      UserInfo,
      ConfigUserData,
      UserScans,
      UserPayment,
      ReportShow,
      UserLog,
      UserEmailLog,
      PaymentsHistory
    },
    computed: {
      ...mapGetters({
        userData: 'users/userShow',
        reportData: 'users/reportData',
        reportInfo: 'users/reportInfo',
        formatData: 'formatData/getFormates',
      }),
    },
    data () {
      return {
        page: this.$route.name,
        activeTab: 'userInfo',
        disable: false,
        imgArray: [],
        isScreenProcess: false,
        isUserInfoScreenProcess: false,
        isConfigScreenProcess: false,
        isReportScreenProcess: false,
        isPaymentInfoScreenProcess: false,
        isPaymentHistoryScreenProcess: false,
        isUserLogScreenProcess: false,
        isGeneratePDF: false,
        modules:'users',
      }
    },
    created () {
      if (this.$route.params.id) {
        this.$store.dispatch('users/userShow', this.$route.params.id)
      } else {
        this.$store.dispatch('users/clearCurrentUser')
      }
       this.$store.dispatch('formatData/getFormatData')

    },
    methods: {
      toggleConfig () {
          this.isUserInfoScreenProcess = false;
          this.isConfigScreenProcess = true;
      },
      toggleReport () {
          this.isConfigScreenProcess = false;
          this.isReportScreenProcess = true;
      },
      togglePaymentInfo () {
          this.isReportScreenProcess = false;
          this.isPaymentInfoScreenProcess = true;
      },
      togglePaymentHistory () {
          this.isPaymentInfoScreenProcess = false;
          this.isPaymentHistoryScreenProcess = true;
      },
      toggleUserLog () {
          this.isPaymentHistoryScreenProcess = false;
          this.isUserLogScreenProcess = true;
      },
      changeTab (tabName, formData) {
        // userInfoForm
        this.activeTab = tabName
        this.$store.dispatch('users/clearCurrentUser', formData)
      },
      moveToSecontTab (tabName, formData) {
        if (this.page === 'user-create') {
          let stat = false;
          this.$refs.userInfoForm.$refs.userInfoTab.validate(valid => {
            stat = valid
          })
          return stat

        }

      },
      takeScreenshots () {
        this.isScreenProcess = true;
        this.isUserInfoScreenProcess = true;
      },
      addNewImage (imgURL) {
        const screens = this.imgArray;
        screens.push(imgURL);
        this.imgArray = screens;
      },
      triggerNextTab (newTab) {
        if (!newTab) {
          this.isUserLogScreenProcess = false;
          this.isScreenProcess = false;
          this.isGeneratePDF = true;
          this.activeTab = 'userInfo';
          return false;
        }
        this.activeTab = newTab;
      },
      disableGeneratePDF () {
          this.isGeneratePDF = false;
      },
      getDateEDTFormat(date) {
        if(!date) {
          return
        }

        const options = {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        };

        return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
      },

    },
  }
</script>

<style scoped lang="scss">
    .user-edite-page {

    }

    .name {
        font-weight: 700;
        font-size: 1.5em;
    }

    .created_at {
        font-size: 0.9em;
    }

    .top-bar {
        margin-bottom: -25px;
    }

    /* Анимации появления и исчезновения могут иметь */
    /* различные продолжительности и динамику.       */
    .slide-fade-enter-active {
        transition: all .2s ease;
    }

    .slide-fade-leave-active {
        transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active до версии 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

</style>
